<template>
  <!-- 用户教育机构人才修改进度2 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("humanResourcesPosting") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{ $t("resume") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          2<span class="progress-title">{{ $t("careerRequest") }}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          3<span class="progress-title">{{ $t("confirm") }}</span>
        </div>
        <div class="line-between-normal"></div>
      </div>
      <!-- 第一行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("dateAdmission") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="enrollment"
              type="date"
              @change="dataTimeChange1"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("graduationDate") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="graduation"
              type="date"
              @blur="dataTimeChange2"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("education") }}<span>*</span></p>
          <div class="block">
            <el-dropdown @command="handleCommandEducation">
              <span class="el-dropdown-link">
                {{ education }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item3, index) in educationData"
                  :key="index.code"
                  :command="item3"
                  >{{ item3.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 第二行 -->
      <div class="one-line-box">
        <div class="big-box">
          <p class="box-title">{{ $t("school") }}<span>*</span></p>
          <el-input
            v-model="school"
            @blur="inputData(1)"
            maxlength="100"
          ></el-input>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("major") }}<span>*</span></p>
          <el-input
            v-model="profession"
            @blur="inputData(2)"
            maxlength="100"
          ></el-input>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("startYear") }}</p>
          <div class="block">
            <el-date-picker
              v-model="startYear"
              type="date"
              @blur="dataTimeChange3"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("endDate") }}</p>
          <div class="block">
            <el-date-picker
              v-model="endYear"
              type="date"
              @blur="dataTimeChange4"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <!-- 第四行 -->
      <div class="one-line-box">
        <div class="big-box">
          <p class="box-title">{{ $t("workPlace") }}</p>
          <el-input
            v-model="workPlace"
            @blur="inputData(3)"
            maxlength="100"
          ></el-input>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("belongs") }}</p>
          <el-input
            v-model="type"
            @blur="inputData(4)"
            maxlength="100"
          ></el-input>
        </div>
      </div>
      <!-- 第五行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("preferredWorkplace") }}<span>*</span></p>
          <el-input
            v-model="hopeWorkplace"
            @blur="inputData(5)"
            maxlength="100"
          ></el-input>
        </div>
        <div class="small-box">
          <p class="box-title">{{ $t("desiredHireTime") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="hopeEntryTime"
              type="date"
              @blur="dataTimeChange5"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="small-box">
          <p class="box-title">
            {{ $t("desiredOccupationCategory") }}<span>*</span>
          </p>
          <el-dropdown @command="handleCommandHopeWorkType">
            <span class="el-dropdown-link">
              {{ hopeWorkType
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item2, index) in hopeWorkTypeData"
                :key="item2.code"
                :command="item2"
                >{{ item2.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 第六行 -->
      <div class="label-line-box">
        <p class="box-title">{{ $t("employmentForm") }}</p>
        <div
          :class="hopeForm1 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(1)"
        >
          {{ $t("fullTimeEmployee") }}<span @click.stop="labelDel(1)">×</span>
        </div>
        <div
          :class="hopeForm2 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(2)"
        >
          {{ $t("partTimeJob") }}<span @click.stop="labelDel(2)">×</span>
        </div>
        <div
          :class="hopeForm3 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(3)"
        >
          {{ $t("specificSkill") }}<span @click.stop="labelDel(3)">×</span>
        </div>
        <div
          :class="hopeForm4 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(4)"
        >
          {{ $t("technicalInternTrainee")
          }}<span @click.stop="labelDel(4)">×</span>
        </div>
      </div>
      <!-- 第七行 -->
      <div class="one-line-box">
        <div class="max-small-box">
          <p class="box-title">{{ $t("expectedSalary") }} <span>*</span></p>
          <el-dropdown @command="handleCommandHopeSalary">
            <span class="el-dropdown-link">
              {{ hopeSalary }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item3, index) in hopeSalaryData"
                :key="index.code"
                :command="item3"
                >{{ item3.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="small-box margin-small-box">
          <el-input
            v-model="startSalary"
            @input="inputData(6)"
            maxlength="11"
          ></el-input>
        </div>
        <span class="tali">~</span>
        <div class="small-box">
          <el-input
            v-model="endSalary"
            @input="inputData(7)"
            maxlength="11"
          ></el-input>
        </div>
      </div>
      <!-- 第八行 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="box-title">{{ $t("otherWishes") }}<span>*</span></p>
          <el-input
            v-model="otherHope"
            type="textarea"
            @blur="inputData(8)"
            maxlength="255"
          ></el-input>
        </div>
      </div>
      <!-- 第九行 -->
      <div class="line-button-box">
        <button class="button-css1" @click="handleButton1">
          {{ $t("return") }}
        </button>
        <button class="button-css1" @click="handleButton2" :disabled="isLock">
          {{ $t("temporarilySaved") }}
        </button>
        <button class="button-css2" @click="handleButton3">
          {{ $t("next") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { resumeDetailQuery, resumeUpdateInfo } from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "userEducationInstitutionsToModifyTheSchedule2",
  components: {},
  data() {
    return {
      flag: 0,
      isLock: false,
      value1: "",
      education: "", //
      userId: "",
      enrollment: "", //入学年月
      graduation: "", //卒業年月
      school: "", //学校
      profession: "", //専攻
      startYear: "", //開始年月
      endYear: "", //終了年月
      type: "", ////所属
      workPlace: "", //勤め先 工作地
      hopeWorkplace: "", //希望勤務地 希望工作地点
      startSalary: "", //开始的薪水
      endSalary: "", //最终薪水
      otherHope: "", //他のご希望
      hopeEntryTime: "", //希望入社時間
      hopeWorkType: "", //期望的职业类别
      hopeSalary: "", //希望給与
      hopeForm1: 0,
      hopeForm2: 0,
      hopeForm3: 0,
      hopeForm4: 0,
      labelListHandle: [],
      educationData: [],
      educationCode: "",
      hopeWorkTypeData: [],
      hopeSalaryData: [],
      hopeWorkTypeCode: "",
      hopeSalaryCode: "",
      userInfo: "",
      avatarUrl: "",
      judgeContinue: false,
      hopeWorkType_dictText: "",
      language: "",
      resumeInfo: [],
      sex_dictText: "",
      japanese_dictText: "",
      english_dictText: "",
      education_dictText: "",
      hopeWorktype_dictText: "",
      hopeSalary_dictText: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.resumeInfo = this.$route.params.resumeInfo;
    console.log(this.$route, "created.$route");
    //修改1接收的值
    this.name = this.$route.params.name;
    this.avatar = this.$route.params.avatar;
    this.anonym = this.$route.params.anonym;
    this.birth = this.$route.params.birth;
    this.telephone = this.$route.params.telephone;
    this.email = this.$route.params.email;
    this.address = this.$route.params.address;
    this.other = this.$route.params.other;
    this.qualification1 = this.$route.params.qualification1;
    this.qualification2 = this.$route.params.qualification2;
    this.qualification3 = this.$route.params.qualification3;
    this.pr = this.$route.params.pr;
    this.resumeId = this.$route.params.resumeId;
    this.label1 = this.$route.params.label1;
    this.label2 = this.$route.params.label2;
    this.label3 = this.$route.params.label3;
    this.label4 = this.$route.params.label4;
    this.principal = this.$route.params.principal;

    //下拉
    this.sex = this.$route.params.sex;
    this.japanese = this.$route.params.japanese;
    this.english = this.$route.params.english;
    this.sexCode = this.$route.params.sexCode;
    this.japaneseCode = this.$route.params.japaneseCode;
    this.englishCode = this.$route.params.englishCode;
    this.avatarUrl = this.$route.params.avatarUrl;
    console.log("flag:" + this.avatarUrl);
    if ((this.$route.params.flag||0) !== 1) {
      //修改2接收的值
      this.getResumeDetailQuery(this.resumeId);
    } else {
      this.education = this.$route.params.education;
      this.enrollment = this.$route.params.enrollment || "";
      this.graduation = this.$route.params.graduation;
      this.startYear = this.$route.params.startYear;
      this.endYear = this.$route.params.endYear;
      this.workPlace = this.$route.params.workPlace;
      this.startSalary = this.$route.params.startSalary;
      this.endSalary = this.$route.params.endSalary;
      this.otherHope = this.$route.params.otherHope;
      this.hopeWorkplace = this.$route.params.hopeWorkplace;
      this.type = this.$route.params.type;
      this.school = this.$route.params.school;
      this.hopeForm1 = this.$route.params.hopeForm1;
      this.hopeForm2 = this.$route.params.hopeForm2;
      this.hopeForm3 = this.$route.params.hopeForm3;
      this.hopeForm4 = this.$route.params.hopeForm4;
      this.flag = this.$route.params.flag;

      this.resumeId = this.$route.params.resumeId;
      this.profession = this.$route.params.profession;
      //下拉
      this.hopeEntryTime = this.$route.params.hopeEntryTime;
      this.hopeWorkType = this.$route.params.hopeWorkType;
      this.hopeSalary = this.$route.params.hopeSalary;
      this.hopeEntryTimeCode = this.$route.params.hopeEntryTimeCode;
      this.hopeWorkTypeCode = this.$route.params.hopeWorkTypeCode;
      this.hopeSalaryCode = this.$route.params.hopeSalaryCode;
    }

    this.getHopeSalary();
    this.getHopeWorkType();
    this.getEducation();
    this.getAES();
  },
  activated(){
    this.resumeInfo = this.$route.params.resumeInfo;
    console.log("activated.$route",this.$route.params );
    //修改1接收的值
    this.name = this.$route.params.name;
    this.avatar = this.$route.params.avatar;
    this.anonym = this.$route.params.anonym;
    this.birth = this.$route.params.birth;
    this.telephone = this.$route.params.telephone;
    this.email = this.$route.params.email;
    this.address = this.$route.params.address;
    this.other = this.$route.params.other;
    this.qualification1 = this.$route.params.qualification1;
    this.qualification2 = this.$route.params.qualification2;
    this.qualification3 = this.$route.params.qualification3;
    this.pr = this.$route.params.pr;
    this.resumeId = this.$route.params.resumeId;
    this.label1 = this.$route.params.label1;
    this.label2 = this.$route.params.label2;
    this.label3 = this.$route.params.label3;
    this.label4 = this.$route.params.label4;
    this.principal = this.$route.params.principal;

    //下拉
    this.sex = this.$route.params.sex;
    this.japanese = this.$route.params.japanese;
    this.english = this.$route.params.english;
    this.sexCode = this.$route.params.sexCode;
    this.japaneseCode = this.$route.params.japaneseCode;
    this.englishCode = this.$route.params.englishCode;
    this.avatarUrl = this.$route.params.avatarUrl;
    console.log("flag:" + this.avatarUrl);
    if ((this.$route.params.flag||0) !== 1) {
      //修改2接收的值
      // this.getResumeDetailQuery(this.resumeId);
    } else {
      this.education = this.$route.params.education;
      this.enrollment = this.$route.params.enrollment || "";
      this.graduation = this.$route.params.graduation;
      this.startYear = this.$route.params.startYear;
      this.endYear = this.$route.params.endYear;
      this.workPlace = this.$route.params.workPlace;
      this.startSalary = this.$route.params.startSalary;
      this.endSalary = this.$route.params.endSalary;
      this.otherHope = this.$route.params.otherHope;
      this.hopeWorkplace = this.$route.params.hopeWorkplace;
      this.type = this.$route.params.type;
      this.school = this.$route.params.school;
      this.hopeForm1 = this.$route.params.hopeForm1;
      this.hopeForm2 = this.$route.params.hopeForm2;
      this.hopeForm3 = this.$route.params.hopeForm3;
      this.hopeForm4 = this.$route.params.hopeForm4;
      this.flag = this.$route.params.flag;

      this.resumeId = this.$route.params.resumeId;
      this.profession = this.$route.params.profession;
      //下拉
      this.hopeEntryTime = this.$route.params.hopeEntryTime;
      this.hopeWorkType = this.$route.params.hopeWorkType;
      this.hopeSalary = this.$route.params.hopeSalary;
      this.hopeEntryTimeCode = this.$route.params.hopeEntryTimeCode;
      this.hopeWorkTypeCode = this.$route.params.hopeWorkTypeCode;
      this.hopeSalaryCode = this.$route.params.hopeSalaryCode;
    }
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    // input校验
    inputData(num) {
      var vc2 = /^\d{1,10}$/;
      var vc3 = /^.{1,99}$/;
      var vc4 = /^.{1,254}$/;

      if (num === 1) {
        console.log("1:" + this.school);
        if (this.school === "") {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc3.test(this.school)) {
          this.$message({
            message: this.$t("waringSchool"),
            type: "warning"
          });
        }
      } else if (num === 2) {
        if (this.profession === "") {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc3.test(this.profession)) {
          this.$message({
            message: this.$t("waringProfession"),
            type: "warning"
          });
        }
      } else if (num === 3) {
        if (!vc3.test(this.workPlace)) {
          this.$message({
            message: this.$t("waringWorkPlace"),
            type: "warning"
          });
        }
      } else if (num === 4) {
        if (!vc3.test(this.type)) {
          this.$message({
            message: this.$t("waringType"),
            type: "warning"
          });
        }
      } else if (num === 5) {
        if (this.hopeWorkplace === "") {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc3.test(this.hopeWorkplace)) {
        } else {
          this.$message({
            message: this.$t("waringHopeWorkplace"),
            type: "warning"
          });
        }
      } else if (num === 6) {
        if (!vc2.test(this.startSalary)) {
          //int
          this.$message({
            message: this.$t("waringStartSalary"),
            type: "warning"
          });
        }
      } else if (num === 7) {
        if (!vc2.test(this.endSalary)) {
          //int
          this.$message({
            message: this.$t("waringEndSalary"),
            type: "warning"
          });
        }
      } else if (num === 8) {
        if (this.otherHope === "") {
          this.$message({
            message: this.$t("dataEmpty"),
            type: "warning"
          });
        } else if (!vc4.test(this.otherHope)) {
          this.$message({
            message: this.$t("waringOtherHope"),
            type: "warning"
          });
        }
      }
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        if ((this.$route.params.flag||0) !== 1) {
          that.getResumeDetailQuery(that.resumeId);
        }
        that.getHopeSalary();
        that.getHopeWorkType();
        that.getEducation();
        that.getAES();
      }
    },
    //获得语言
    getDictText() {
      console.log("获得语言");
      console.log(this.language);
      if (this.language === "CN" || this.language === "zh-CN") {
        this.hopeWorkType = this.resumeInfo.hopeWorktype_dictText;
        this.education = this.resumeInfo.education_dictText;
        this.hopeSalary = this.resumeInfo.hopeSalary_dictText;
      } else {
        this.hopeWorkType = this.resumeInfo.jphopeWorktype_dictText;
        this.education = this.resumeInfo.jpeducation_dictText;
        this.hopeSalary = this.resumeInfo.jphopeSalary_dictText;
      }
    },
    //按钮1 返回
    handleButton1() {
      console.log("返回-按钮", {
          resumeInFo: this.resumeInfo,
          flag: 1,
          name: this.name,
          userId: this.userId,
          anonym: this.anonym,
          birth: this.birth,
          avatar: this.avatar,
          telephone: this.telephone,
          email: this.email,
          address: this.address,
          other: this.other,
          qualification1: this.qualification1,
          qualification2: this.qualification2,
          qualification3: this.qualification3,
          pr: this.pr,
          resumeId: this.resumeId,
          label1: this.label1,
          label2: this.label2,
          label3: this.label3,
          label4: this.label4,
          avatarUrl: this.avatarUrl,
          //下拉
          sex: this.sex,
          japanese: this.japanese,
          english: this.english,
          sexCode: this.sexCode,
          japaneseCode: this.japaneseCode,
          englishCode: this.englishCode
        });
      this.$router.push({
        path: "/userEducationInstitutionsToModifyTheSchedule1",
        name: "userEducationInstitutionsToModifyTheSchedule1",
        params: {
          resumeInFo: this.resumeInfo,
          flag: 1,
          name: this.name,
          userId: this.userId,
          anonym: this.anonym,
          birth: this.birth,
          avatar: this.avatar,
          telephone: this.telephone,
          email: this.email,
          address: this.address,
          other: this.other,
          qualification1: this.qualification1,
          qualification2: this.qualification2,
          qualification3: this.qualification3,
          pr: this.pr,
          resumeId: this.resumeId,
          label1: this.label1,
          label2: this.label2,
          label3: this.label3,
          label4: this.label4,
          avatarUrl: this.avatarUrl,
          //下拉
          sex: this.sex,
          japanese: this.japanese,
          english: this.english,
          sexCode: this.sexCode,
          japaneseCode: this.japaneseCode,
          englishCode: this.englishCode
        }
      });
    },
    //按钮2 保存
    handleButton2() {
      console.log("保存-按钮");
      // console.log("薪资按钮长度:"+this.profession.length)
      this.judgeData();
      this.isLock = true;
      if (this.judgeContinue === false) {
        var resumeDTO = {
          address: this.address, //地址
          anonym: this.anonym, //假名
          avatar: this.avatar, //头像
          birth: this.birth, //生日
          education: this.educationCode,
          email: this.email, //邮箱
          endSalary: this.endSalary, //年终工资
          endYear: this.endYear, //结束日期
          english: this.englishCode, //英语等级
          enrollment: this.enrollment, //入学
          graduation: this.graduation, //毕业
          hopeEntryTime: this.hopeEntryTime, //希望进入时间
          label1: this.label1,
          label2: this.label2,
          label3: this.label3,
          label4: this.label4,
          hopeForm1: this.hopeForm1, //希望表格1
          hopeForm2: this.hopeForm2, //希望表格2
          hopeForm3: this.hopeForm3, //希望表格3
          hopeForm4: this.hopeForm4, //希望表格4
          hopeSalary: this.hopeSalaryCode, //希望的薪水
          hopeWorkType: this.hopeWorkTypeCode, //希望工作类型
          hopeWorkplace: this.hopeWorkplace, //希望工作地点
          japanese: this.japaneseCode, //日语等级
          name: this.name, //名字
          other: this.other, //其他
          otherHope: this.otherHope, //其他希望
          pr: this.pr, //PR
          profession: this.profession, //职业
          qualification1: this.qualification1, //资格1
          qualification2: this.qualification2, //资格2
          qualification3: this.qualification3, //资格3
          resumeId: this.resumeId, //职位id
          school: this.school, //学校
          sex: this.sexCode, //性别
          startSalary: this.startSalary, //开始的薪水
          startYear: this.startYear, //开始年份
          telephone: this.telephone, //电话号
          type: this.type,
          workPlace: this.workPlace //工作地
        };
        console.log("使用修改接口");
        console.log(resumeDTO);
        resumeUpdateInfo(resumeDTO)
          .then(res => {
            console.log("--------求人信息修改接口数据--------");
            console.log(res);
            if (res.data.code === "A0000") {
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              this.isLock = false;
              if (this.userInfo.roleName === "educationalinstitutionadmin") {
                console.log("跳转至管理员10-2");
                this.$router.push({
                  path: "/educationalInstitutionTalentListView",
                  name: "educationalInstitutionTalentListView"
                });
              } else if (
                this.userInfo.roleName === "educationalinstitutionuser"
              ) {
                console.log("跳转至用户10-5");
                this.$router.push({
                  path: "/userEducationalInstitutionTalentListView",
                  name: "userEducationalInstitutionTalentListView"
                });
              }
            }
          })
          .catch(res => {
            console.log("人才信息详情查看接口异常:", res);
          });
      }
    },
    //按钮3 下一个
    handleButton3() {
      console.log("下一个-按钮2=>3", this.avatarUrl);
      this.judgeData();
      if (this.judgeContinue === false) {
        this.$router.push({
          path: "/userEducationInstitutionsToModifyTheSchedule3",
          name: "userEducationInstitutionsToModifyTheSchedule3",
          params: {
            //1
            name: this.name,
            birth: this.birth,
            anonym: this.anonym,
            avatar: this.avatar,
            avatarUrl: this.avatarUrl,
            telephone: this.telephone,
            email: this.email,
            userId: this.userId,
            address: this.address,
            other: this.other,
            qualification1: this.qualification1,
            qualification2: this.qualification2,
            qualification3: this.qualification3,
            pr: this.pr,
            resumeId: this.resumeId,
            label1: this.label1,
            label2: this.label2,
            label3: this.label3,
            label4: this.label4,
            avatarUrl: this.avatarUrl,
            // 下拉
            profession: this.profession,
            //2

            hopeForm1: this.hopeForm1, //希望表格1
            hopeForm2: this.hopeForm2, //希望表格2
            hopeForm3: this.hopeForm3, //希望表格3
            hopeForm4: this.hopeForm4, //希望表格4
            enrollment: this.enrollment,
            graduation: this.graduation,
            startYear: this.startYear,
            endYear: this.endYear,
            workPlace: this.workPlace,
            startSalary: this.startSalary,
            endSalary: this.endSalary,
            otherHope: this.otherHope,
            hopeWorkplace: this.hopeWorkplace,
            type: this.type,
            hopeEntryTime: this.hopeEntryTime,
            school: this.school,
            //下拉
            sex: this.sex,
            japanese: this.japanese,
            english: this.english,
            sexCode: this.sexCode,
            japaneseCode: this.japaneseCode,
            englishCode: this.englishCode,
            education: this.education,
            hopeWorkType: this.hopeWorkType,
            hopeSalary: this.hopeSalary,
            educationCode: this.educationCode,
            hopeWorkTypeCode: this.hopeWorkTypeCode,
            hopeSalaryCode: this.hopeSalaryCode
          }
        });
      }
    },
    judgeData() {
      // console.log("长度：")
      // console.log(this.enrollment.length)
      //
      // console.log(this.graduation.length)
      // console.log((String)(this.education).length)
      // console.log("school"+this.school.length)
      // console.log(this.profession.length)
      // console.log(this.hopeWorkplace.length)
      // console.log("hopeEntryTime"+this.hopeEntryTime.length)
      // console.log("11"+(String)(this.hopeWorkType).length)
      // console.log("212"+(String)(this.hopeSalary))
      // console.log("313"+(String)(this.otherHope))
      // console.log("22"+(String)(this.hopeSalary).length)
      // console.log("33"+(String)(this.otherHope).length)
      // // console.log("221"+this.hopeSalary)
      // // console.log("331"+this.otherHope)

      if (
        this.enrollment === "" ||
        this.graduation === "" ||
        this.education === "" ||
        this.school === "" ||
        this.profession === "" ||
        this.hopeWorkplace === "" ||
        this.hopeEntryTime === "" ||
        this.hopeWorkType === "" ||
        this.hopeSalary === "" ||
        this.otherHope === ""
      ) {
        this.$message({
          message: this.$t("dataEmpty"),
          type: "warning"
        });
        this.judgeContinue = true;
      } else {
        this.judgeContinue = false;
      }
    },
    // 获取头部信息
    getAES() {
      var userInfo = localStorage.getItem("userInfo");
      const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
      console.log("userinfo");
      console.log(aesFecInfo);
      this.userInfo = aesFecInfo;
    },
    //下拉提示
    handleCommandHopeWorkType(evt) {
      this.hopeWorkTypeCode = evt.code;
      this.hopeWorkType = evt.name;
    },
    handleCommandHopeSalary(evt) {
      this.hopeSalaryCode = evt.code;
      this.hopeSalary = evt.name;
    },
    handleCommandEducation(evt) {
      this.educationCode = evt.code;
      this.education = evt.name;
    },
    dataTimeChange1() {
      this.enrollment = this.timeJs(this.enrollment);
    },
    dataTimeChange2() {
      this.graduation = this.timeJs(this.graduation);
    },
    dataTimeChange3() {
      this.startYear = this.timeJs(this.startYear);
    },
    dataTimeChange4() {
      this.endYear = this.timeJs(this.endYear);
    },
    dataTimeChange5() {
      this.hopeEntryTime = this.timeJs(this.hopeEntryTime);
    },

    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();
      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.hopeForm1 = 1;
        this.labelListLength(1);
      } else if (num === 2) {
        this.hopeForm2 = 1;
        this.labelListLength(2);
      } else if (num === 3) {
        this.hopeForm3 = 1;
        this.labelListLength(3);
      } else if (num === 4) {
        this.hopeForm4 = 1;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("正社員") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("アルバイト") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("特定技能") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("技能実習生") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("正社員");
      } else if (num === 2) {
        this.labelListHandle.push("アルバイト");
      } else if (num === 3) {
        this.labelListHandle.push("特定技能");
      } else if (num === 4) {
        this.labelListHandle.push("技能実習生");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        this.hopeForm1 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "正社員") {
            this.labelListHandle.splice(i, 1);
          }
        }
      } else if (num === 2) {
        this.hopeForm2 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "アルバイト") {
            this.labelListHandle.splice(i, 1);
          }
        }
      } else if (num === 3) {
        this.hopeForm3 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "特定技能") {
            this.labelListHandle.splice(i, 1);
          }
        }
      } else if (num === 4) {
        this.hopeForm4 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "技能実習生") {
            this.labelListHandle.splice(i, 1);
          }
        }
      }
      console.log(this.labelListHandle);
    },

    getHopeWorkType() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jphopeWorkType";
      } else {
        dataItems = "hopeWorkType";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据hopeWorkType--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.hopeWorkTypeData = aesFecInfo.data;
            console.log(that.hopeWorkTypeData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getHopeSalary() {
      console.log(1);
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jphopeSalary";
      } else {
        dataItems = "hopeSalary";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据hopeSalary--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.hopeSalaryData = aesFecInfo.data;
            console.log(that.hopeSalaryData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getEducation() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpeducation";
      } else {
        dataItems = "education";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据education--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationData = aesFecInfo.data;
            console.log(that.educationData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //人才信息详情查看
    getResumeDetailQuery(id) {
      var fescInfo = {
        resumeId: id
      };
      resumeDetailQuery(fescInfo)
        .then(res => {
          console.log("--------人才信息详情查看接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfoData = JSON.parse(AES.decrypt(res.data.data));
            const aesFecInfo = aesFecInfoData.data[0];
            console.log("aesFecInfo",aesFecInfo);
            console.log(aesFecInfo.enrollment, "userIduserIduserId");
            this.resumeInfo = aesFecInfo;
            this.getDictText();
            if (aesFecInfo.enrollment == "0000-00-00 00:00:00") {
              this.enrollment = "";
            } else {
              this.enrollment = aesFecInfo.enrollment;
            }
            if (aesFecInfo.graduation == "0000-00-00 00:00:00") {
              this.graduation = "";
            } else {
              this.graduation = aesFecInfo.graduation; //卒業年月
            }
            if (aesFecInfo.startYear == "0000-00-00 00:00:00") {
              this.startYear = "";
            } else {
              this.startYear = aesFecInfo.startYear; //現住所
            }
            if (aesFecInfo.endYear == "0000-00-00 00:00:00") {
              this.endYear = "";
            } else {
              this.endYear = aesFecInfo.endYear; //その他this.graduation = aesFecInfo.graduation; //卒業年月
            }
            //卒業年月
            this.userId = aesFecInfo.userId;
            // this.education=aesFecInfo.education//学历

            this.school = aesFecInfo.school; //学校
            this.profession = aesFecInfo.profession; //メール

            this.workPlace = aesFecInfo.workPlace; //工作地
            this.startSalary = aesFecInfo.startSalary; //开始的薪水
            this.endSalary = aesFecInfo.endSalary; //最终薪水
            this.otherHope = aesFecInfo.otherHope; //他のご希望
            this.hopeWorkplace = aesFecInfo.hopeWorkplace; //希望勤務地
            this.type = aesFecInfo.type; //所属
            this.hopeEntryTime = aesFecInfo.hopeEntrytime;
            // this.avatarUrl = aesFecInfo.avatarUrl;
            // this.hopeWorkType=aesFecInfo.hopeWorktype
            // this.hopeSalary=aesFecInfo.hopeSalary
            this.hopeForm1 = parseInt(aesFecInfo.hopeForm1);
            this.hopeForm2 = parseInt(aesFecInfo.hopeForm2);
            this.hopeForm3 = parseInt(aesFecInfo.hopeForm3);
            this.hopeForm4 = parseInt(aesFecInfo.hopeForm4);
            console.log(this.hopeEntryTime,999);
            console.log(this.resumeId);
          }
        })
        .catch(res => {
          console.log("人才信息详情查看接口异常:", res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  width: 700px;
  /* height: 100%; */
  margin: 0 auto;
  padding-bottom: 70px;
}
.top-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 20px;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}
.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}
.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}
.line-center-normal {
  width: 160px;
  height: 2px;
  background: #dce3e9;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}

.one-line-box {
  height: 45px;
  width: 100%;
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding-left: 55px;
  box-sizing: border-box;
}
.small-box {
  width: 160px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 48px;
}

.small-box /deep/ .el-input__inner {
  width: 150px;
  height: 40px;
  border: 2px solid transparent;
  box-sizing: border-box;
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #09101d;
}
.box-title {
  padding: 0 5px;
  height: 20px;
  line-height: 20px;
  background: #ffffff;
  position: absolute;
  top: -10px;
  left: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.box-title span {
  font-weight: 600;
  font-size: 12px;
  margin-left: 2px;
  color: #fc630c;
}
.small-box /deep/ .el-dropdown-link {
  width: 140px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.small-box /deep/ .el-dropdown {
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
}
.small-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 40px;
  margin-right: 5px;
}
.big-box {
  width: 368px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 48px;
}

.big-box /deep/ .el-input__inner {
  width: 355px;
  height: 40px;
  border: 2px solid transparent;
  box-sizing: border-box;
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #09101d;
}
.max-small-box {
  width: 107px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 48px;
}

.max-small-box /deep/ .el-dropdown-link {
  width: 90px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.max-small-box /deep/ .el-dropdown {
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
}
.max-small-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 40px;
  margin-right: 5px;
}
.margin-small-box {
  margin-right: 10px;
}
.tali {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-right: 10px;
}
.big-line-box {
  height: 127px;
  width: 580px;
  margin: 0 auto;
  margin: 25px 0 0 55px;
}
.big-box-css {
  height: 127px;
  width: 580px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box-css /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 107px;
  width: 565px;
  margin-left: 2px;
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.label-line-box {
  width: 640px;
  height: 50px;
  margin: 0 auto;
  margin: 15px 0 0 55px;
  position: relative;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 25px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 25px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.block /deep/ .el-input,
.el-date-editor.el-input__inner {
  width: 155px;
}
</style>



// WEBPACK FOOTER //
// src/pages/userEducationInstitutionsToModifyTheSchedule2/index.vue